export default "__VITE_ASSET__DIMzmFxu__"